import Rx from 'rxjs';
import { combineEpics } from 'redux-observable';

import * as constAction from 'root/actionConstants';
import * as dispositivosActions from 'modules/dispositivos/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import { request } from 'core/generalFunctions';
import { fromJS } from 'immutable';

const { ajax } = Rx.Observable;

export const getEpic = (action$, store) =>
  action$.ofType(constAction.DISPOSITIVO_GET).switchMap((action) =>
    ajax(request(action))
      .map((result) => dispositivosActions.setState({ lista: result.response }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getCodigoEpic = (action$, store) =>
  action$.ofType(constAction.DISPOSITIVO_GET_CODIGO).switchMap((action) =>
    ajax(request(action))
      .map((result) => dispositivosActions.setState({ codigo: result.response }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const deleteEpic = (action$, store) =>
  action$
    .ofType(constAction.DISPOSITIVO_DELETE)
    .throttleTime(500)
    .switchMap((action) =>
      ajax(request(action))
        .mergeMap(() => [dispositivosActions.get(), generalActions.snackbar_show('Dispositivo eliminado')])
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const acceptEpic = (action$, store) =>
  action$
    .ofType(constAction.DISPOSITIVO_ACCEPT)
    .throttleTime(500)
    .switchMap((action) =>
      ajax(request(action))
        .mergeMap(() => [dispositivosActions.get(), generalActions.snackbar_show('Dispositivo aceptado')])
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const requestActionEpic = (action$, store) =>
  action$
    .ofType(constAction.DISPOSITIVO_REQUEST_ACTION)
    .throttleTime(500)
    .switchMap((action) =>
      ajax(request(action))
        .mergeMap(() => [generalActions.snackbar_show('Solicitud enviada')])
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const getFullEpic = (action$, store) =>
  action$
    .ofType(constAction.DISPOSITIVO_GET_FULL)
    .throttleTime(1500)
    .switchMap((action) =>
      ajax(request(action))
        .map((result) => dispositivosActions.setState({ dispositivoActual: result.response }))
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const getPhotoUrlEpic = (action$, store) =>
  action$.ofType(constAction.DISPOSITIVO_GET_PHOTO_URL).switchMap((action) =>
    ajax(request(action))
      .map((result) => dispositivosActions.setState({ photoTaskUrl: result.response }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getMoreTasksEpic = (action$, store) =>
  action$
    .ofType(constAction.DISPOSITIVO_GET_MORE_TASKS)
    .throttleTime(1500)
    .switchMap((action) =>
      ajax(request(action))
        .map((result) => {
          const dispositivoActual = store.getState().getIn(['dispositivos', 'dispositivoActual']);
          const newTasks = fromJS(result.response);
          const currentTasks = dispositivoActual.get('_dispositivoTask');
          const updatedTasks = currentTasks.concat(newTasks);
          const updatedDispositivo = dispositivoActual.set('_dispositivoTask', updatedTasks);
          return dispositivosActions.setState({ dispositivoActual: updatedDispositivo });
        })
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export default combineEpics(getEpic, deleteEpic, acceptEpic, getCodigoEpic, requestActionEpic, getFullEpic, getPhotoUrlEpic, getMoreTasksEpic);



// WEBPACK FOOTER //
// src/modules/dispositivos/epics.js